import { NgModule } from '@angular/core';
import { ThemingService } from './services/theming.service';


@NgModule({})
export class ThemingModule {
  constructor(private _theming: ThemingService) {}
}
